/**
 * Toàn bộ chữ hiển thị của ứng dụng, gom về một chỗ.
 *
 * Khóa được khai báo `as const` nên `MessageKey` là hợp của đúng những khóa có thật: gõ sai một
 * khóa sẽ thành lỗi biên dịch chứ không phải một ô trống lặng lẽ trên màn hình.
 *
 * LƯU Ý: những chuỗi ở đây chỉ để HIỂN THỊ. Trạng thái công việc lưu trong database là chuỗi tiếng
 * Việt do máy chủ quy định ("đã hoàn thành", "chưa hoàn thành", "hoàn thành x/y") — xem
 * utils/taskStatus.ts. Dù giao diện đang là tiếng Anh thì giá trị gửi lên vẫn phải là tiếng Việt.
 */
export const messages = {
  'app.name': { vi: 'Việc mỗi ngày', en: 'Daily Work' },

  'nav.today': { vi: 'Hôm nay', en: 'Today' },
  'nav.calendar': { vi: 'Lịch', en: 'Calendar' },
  'nav.stats': { vi: 'Thống kê', en: 'Statistics' },
  'nav.help': { vi: 'Hướng dẫn', en: 'Help' },
  'nav.comingSoon': { vi: 'Sắp có', en: 'Coming soon' },

  'header.changePassword': { vi: 'Đổi mật khẩu', en: 'Change password' },
  'header.signOut': { vi: 'Đăng xuất', en: 'Sign out' },
  'header.signIn': { vi: 'Đăng nhập', en: 'Sign in' },
  'header.toLight': { vi: 'Chuyển sang giao diện sáng', en: 'Switch to light theme' },
  'header.toDark': { vi: 'Chuyển sang giao diện tối', en: 'Switch to dark theme' },
  'header.language': { vi: 'Ngôn ngữ', en: 'Language' },

  'sidebar.todoDaily': { vi: 'Todo Daily', en: 'Todo Daily' },

  'day.prev': { vi: 'Ngày trước', en: 'Previous day' },
  'day.next': { vi: 'Ngày sau', en: 'Next day' },
  'day.pick': { vi: 'Chọn ngày', en: 'Pick a date' },
  'day.today': { vi: 'Hôm nay', en: 'Today' },
  'day.yesterday': { vi: 'Hôm qua', en: 'Yesterday' },
  'day.tomorrow': { vi: 'Ngày mai', en: 'Tomorrow' },

  'day.summary.todos': { vi: '{count} todo', en: '{count} todos' },
  'day.summary.done': { vi: '{done}/{total} công việc đã xong', en: '{done}/{total} tasks done' },
  'day.summary.partial': { vi: '{count} dở dang', en: '{count} in progress' },

  'day.addTooltip': { vi: 'Thêm todo cho ngày này', en: 'Add a todo for this day' },
  'day.newPlaceholder': { vi: 'Thêm một todo cho ngày này…', en: 'Add a todo for this day…' },
  'day.add': { vi: 'Thêm', en: 'Add' },
  'day.cancel': { vi: 'Hủy', en: 'Cancel' },
  'day.searchPlaceholder': { vi: 'Tìm theo tiêu đề…', en: 'Search by title…' },

  'day.filter.all': { vi: 'Tất cả', en: 'All' },
  'day.filter.notCompleted': { vi: 'Chưa hoàn thành', en: 'Not completed' },
  'day.filter.partial': { vi: 'Đang dở dang', en: 'In progress' },
  'day.filter.completed': { vi: 'Đã hoàn thành', en: 'Completed' },
  'day.filterLabel': { vi: 'Lọc theo trạng thái', en: 'Filter by status' },

  'day.empty.title': { vi: 'Ngày này chưa có việc nào', en: 'Nothing planned for this day' },
  'day.empty.body': {
    vi: 'Bấm dấu cộng ở góc trên bên phải để ghi việc đầu tiên. Mỗi todo là một bảng công việc: bên trong nó bạn thêm từng đầu việc nhỏ, đánh dấu xong, xong một phần, hoặc chưa làm.',
    en: 'Use the plus button at the top right to add your first one. A todo is a small board: inside it you add individual tasks and mark each one done, partly done, or not started.'
  },
  'day.noMatch': { vi: 'Không có todo nào khớp bộ lọc.', en: 'No todo matches the filter.' },
  'day.dragLocked': {
    vi: 'Đang lọc nên tạm khóa kéo-thả sắp xếp.',
    en: 'Reordering is paused while a filter is on.'
  },

  'day.carryOver': {
    vi: 'Còn {count} việc chưa xong từ những ngày trước',
    en: '{count} unfinished from earlier days'
  },
  'day.moveHere': { vi: 'Chuyển sang {date}', en: 'Move to {date}' },
  'day.moved': { vi: 'Đã chuyển "{title}" sang ngày này.', en: 'Moved "{title}" to this day.' },

  'todo.deleted': { vi: 'Đã xóa "{title}".', en: 'Deleted "{title}".' },
  'todo.undo': { vi: 'HOÀN TÁC', en: 'UNDO' },
  'todo.restored': { vi: 'Đã khôi phục.', en: 'Restored.' },
  'todo.delete': { vi: 'Xóa', en: 'Delete' },
  'todo.deleteAria': { vi: 'Xóa {title}', en: 'Delete {title}' },
  'todo.dragHandle': { vi: 'Kéo để đổi thứ tự', en: 'Drag to reorder' },
  'todo.target': { vi: 'Mục tiêu {time}', en: 'Target {time}' },

  'todo.counts.done': { vi: '{done}/{total} xong', en: '{done}/{total} done' },
  'todo.counts.partial': { vi: '{count} dở dang', en: '{count} in progress' },
  'todo.counts.notCompleted': { vi: '{count} chưa làm', en: '{count} not started' },
  'todo.counts.empty': { vi: 'Chưa có công việc nào', en: 'No tasks yet' },

  'status.completed': { vi: 'Đã hoàn thành', en: 'Completed' },
  'status.partial': { vi: 'Hoàn thành một phần', en: 'Partly completed' },
  'status.notCompleted': { vi: 'Chưa hoàn thành', en: 'Not completed' },

  'priority.none': { vi: 'Không đặt', en: 'None' },
  'priority.low': { vi: 'Thấp', en: 'Low' },
  'priority.medium': { vi: 'Vừa', en: 'Medium' },
  'priority.high': { vi: 'Cao', en: 'High' },
  'priority.label': { vi: 'Mức ưu tiên', en: 'Priority' },
  'priority.badge': { vi: 'Ưu tiên {level}', en: '{level} priority' },

  'taskStatus.none': { vi: 'Chưa có', en: 'None' },
  'taskStatus.notCompleted': { vi: 'Chưa hoàn thành', en: 'Not completed' },
  'taskStatus.partial': { vi: 'Hoàn thành x/y', en: 'Partly done x/y' },
  'taskStatus.completed': { vi: 'Đã hoàn thành', en: 'Completed' },
  'taskStatus.label': { vi: 'Trạng thái công việc', en: 'Task status' },
  'taskStatus.doneUnits': { vi: 'Số phần đã xong', en: 'Units done' },
  'taskStatus.totalUnits': { vi: 'Tổng số phần', en: 'Total units' },

  'taskStage.new': { vi: 'Bắt đầu', en: 'Start' },
  'taskStage.inProcess': { vi: 'Đang làm', en: 'In process' },
  'taskStage.end': { vi: 'Kết thúc', en: 'End' },
  'taskStage.startAria': { vi: 'Bắt đầu công việc này', en: 'Start this task' },
  'taskStage.finishAria': { vi: 'Kết thúc công việc này', en: 'Finish this task' },
  'taskStage.finishNeedsResult': {
    vi: 'Phải nhập kết quả trước khi kết thúc',
    en: 'Enter a result before finishing'
  },
  'taskStage.restart': { vi: 'Bắt đầu lại', en: 'Restart' },
  'taskStage.restartReasonLabel': { vi: 'Lý do bắt đầu lại', en: 'Reason for restarting' },
  'taskStage.restartReasonPlaceholder': {
    vi: 'Vì sao muốn làm lại từ đầu?',
    en: 'Why start this over?'
  },
  'taskStage.restartReasonRequired': { vi: 'Phải nhập lý do.', en: 'A reason is required.' },
  'taskStage.restartConfirm': { vi: 'Xác nhận', en: 'Confirm' },
  'taskStage.restartCancel': { vi: 'Hủy', en: 'Cancel' },
  'taskStage.restartHistory': { vi: 'Đã bắt đầu lại {count} lần', en: 'Restarted {count} times' },

  'targetTime.label': { vi: 'Thời gian mục tiêu', en: 'Target time' },
  'targetTime.none': { vi: 'Không đặt', en: 'None' },
  'targetTime.exact': { vi: 'Ngày giờ cụ thể', en: 'Exact date and time' },
  'targetTime.timeOfDay': { vi: 'Giờ trong ngày', en: 'Time of day' },
  'targetTime.duration': { vi: 'Sau bao lâu nữa', en: 'In how long' },
  'targetTime.timeOfDayHint': {
    vi: 'Hiểu là giờ đó của chính ngày ghi trong todo.',
    en: 'Read as that clock time on the day the todo belongs to.'
  },
  'targetTime.durationHint': {
    vi: 'Tính từ bây giờ, hoặc từ 0h của ngày todo nếu ngày đó còn ở tương lai.',
    en: 'Counted from now, or from midnight of the todo day if that day is still ahead.'
  },
  'targetTime.minutes': { vi: 'phút', en: 'minutes' },

  'detail.back': { vi: 'Quay lại {day}', en: 'Back to {day}' },
  'detail.edit': { vi: 'Sửa todo', en: 'Edit todo' },
  'detail.close': { vi: 'Đóng', en: 'Close' },
  'detail.deleteTodo': { vi: 'Xóa todo', en: 'Delete todo' },
  'detail.linked': { vi: 'Liên kết {table} #{id}', en: 'Linked to {table} #{id}' },
  'detail.tasks': { vi: 'Công việc trong todo', en: 'Tasks in this todo' },
  'detail.empty': {
    vi: 'Chưa có công việc nào. Thêm từng đầu việc nhỏ ở phía dưới rồi đánh dấu tiến độ cho từng cái.',
    en: 'No tasks yet. Add them below, then mark the progress of each one.'
  },
  'detail.stat.total': { vi: 'tổng số', en: 'total' },
  'detail.stat.done': { vi: 'đã xong', en: 'done' },
  'detail.stat.partial': { vi: 'dở dang', en: 'in progress' },
  'detail.stat.notDone': { vi: 'chưa làm', en: 'not started' },
  'detail.taskPlaceholder': { vi: 'Thêm một công việc…', en: 'Add a task…' },
  'detail.taskContent': { vi: 'Nội dung công việc', en: 'Task content' },
  'detail.estimate': { vi: 'Thời lượng ước tính, tính bằng phút', en: 'Estimated minutes' },
  'detail.comment': { vi: 'Bình luận', en: 'Comment' },
  'detail.commentDone': { vi: 'Bình luận ✓', en: 'Comment ✓' },
  'detail.commentPlaceholder': {
    vi: 'Ghi chú cho riêng công việc này…',
    en: 'A note for this task only…'
  },
  'detail.deleteTask': { vi: 'Xóa công việc', en: 'Delete task' },
  'detail.confirmDeleteTask': {
    vi: 'Xóa công việc "{content}"?',
    en: 'Delete the task "{content}"?'
  },
  'detail.taskDeleted': { vi: 'Đã xóa "{content}".', en: 'Deleted "{content}".' },
  'detail.addItem': { vi: 'Thêm một mục mới…', en: 'Add a new item…' },
  'detail.toggleDone': { vi: 'Đánh dấu đã hoàn thành', en: 'Mark as completed' },
  'detail.showDetails': { vi: 'Mở chi tiết công việc', en: 'Show task details' },
  'detail.hideDetails': { vi: 'Thu gọn', en: 'Hide details' },
  'detail.progress': { vi: '{done}/{total}', en: '{done}/{total}' },
  'detail.extraCounts': { vi: '{partial} dở dang · {notDone} chưa làm', en: '{partial} in progress · {notDone} not started' },
  'detail.title': { vi: 'Tiêu đề', en: 'Title' },
  'detail.day': { vi: 'Ngày', en: 'Day' },
  'detail.save': { vi: 'Lưu', en: 'Save' },

  'note.button': { vi: 'Ghi chú', en: 'Notes' },
  'note.title': { vi: 'Sổ ghi chú', en: 'Notebook' },
  'note.addTab': { vi: 'Thêm tab', en: 'Add tab' },
  'note.newTabName': { vi: 'Tab mới', en: 'New tab' },
  'note.tabName': { vi: 'Tên tab', en: 'Tab name' },
  'note.renameHint': { vi: 'Nhấp đúp vào tên tab để sửa', en: 'Double-click a tab name to rename it' },
  'note.deleteTab': { vi: 'Xóa tab', en: 'Delete tab' },
  'note.confirmDeleteTab': {
    vi: 'Xóa tab "{title}" cùng toàn bộ nội dung bên trong?',
    en: 'Delete the tab "{title}" and everything in it?'
  },
  'note.contentPlaceholder': { vi: 'Ghi vào đây…', en: 'Write here…' },
  'note.empty': {
    vi: 'Chưa có tab nào. Bấm dấu cộng để tạo tab đầu tiên.',
    en: 'No tabs yet. Use the plus button to create the first one.'
  },
  'note.saved': { vi: 'Đã lưu ghi chú.', en: 'Notes saved.' },
  'note.unsaved': { vi: 'Có thay đổi chưa lưu', en: 'Unsaved changes' },

  'auth.signIn.title': { vi: 'Đăng nhập', en: 'Sign in' },
  'auth.signIn.busy': { vi: 'Đang đăng nhập…', en: 'Signing in…' },
  'auth.email': { vi: 'Email', en: 'Email' },
  'auth.password': { vi: 'Mật khẩu', en: 'Password' },
  'auth.noAccount': { vi: 'Chưa có tài khoản?', en: 'No account yet?' },
  'auth.haveAccount': { vi: 'Đã có tài khoản?', en: 'Already have an account?' },
  'auth.register': { vi: 'Đăng ký', en: 'Register' },
  'auth.register.title': { vi: 'Tạo tài khoản', en: 'Create an account' },
  'auth.register.submit': { vi: 'Tạo tài khoản', en: 'Create account' },
  'auth.register.busy': { vi: 'Đang tạo tài khoản…', en: 'Creating account…' },
  'auth.displayName': { vi: 'Tên hiển thị', en: 'Display name' },
  'auth.confirmPassword': { vi: 'Nhắc lại mật khẩu', en: 'Repeat password' },
  'auth.mismatch': {
    vi: 'Hai lần nhập mật khẩu không giống nhau.',
    en: 'The two passwords do not match.'
  },
  'auth.passwordHint': { vi: 'Ít nhất {count} ký tự.', en: 'At least {count} characters.' },

  'account.title': { vi: 'Tài khoản', en: 'Account' },
  'account.currentPassword': { vi: 'Mật khẩu hiện tại', en: 'Current password' },
  'account.newPassword': { vi: 'Mật khẩu mới', en: 'New password' },
  'account.confirmNew': { vi: 'Nhắc lại mật khẩu mới', en: 'Repeat new password' },
  'account.submit': { vi: 'Đổi mật khẩu', en: 'Change password' },
  'account.changed': {
    vi: 'Đã đổi mật khẩu. Các thiết bị khác đã bị đăng xuất.',
    en: 'Password changed. Other devices have been signed out.'
  },

  'common.loading': { vi: 'Đang tải…', en: 'Loading…' },
  'common.saving': { vi: 'Đang lưu…', en: 'Saving…' },
  'common.retry': { vi: 'Thử lại', en: 'Try again' },
  'common.checkingSession': { vi: 'Đang kiểm tra phiên đăng nhập…', en: 'Checking your session…' },
  'common.notFound': { vi: 'Không có trang này', en: 'Page not found' },
  'common.backToToday': { vi: 'Về danh sách hôm nay', en: 'Back to today' },
  'common.dismiss': { vi: 'Đóng', en: 'Dismiss' },

  'footer.copyright': {
    vi: '© {year} TodoApp. Bản quyền thuộc về Việc mỗi ngày.',
    en: '© {year} TodoApp. All rights reserved.'
  },
  'footer.terms': { vi: 'Điều khoản sử dụng', en: 'Terms of use' },
  'footer.privacy': { vi: 'Chính sách bảo mật', en: 'Privacy policy' }
} as const;

export type MessageKey = keyof typeof messages;
